/**
 * WordPress dependencies
 */
import { store } from '@wordpress/interactivity';

store('big-bite-stats-perform/match-reports', {
  callbacks: {
    init() {},
  },
});
